import React from 'react';

import type { Props as BookingCardProps } from 'Components/Card/Booking';

import BookingCard from 'Components/Card/Booking';

import { List, Headings } from './Booking.styled';

export interface Props {
    items: BookingCardProps[];
}

const Booking: React.FC<Props> = props => {
    const { items } = props;

    return (
        <>
            {items.length >= 1 && (
                <Headings>
                    <span>Course Reference</span>
                    <span>Date</span>
                    <span>Time</span>
                    <span>Venue</span>
                    <span>Book Online</span>
                </Headings>
            )}
            <List>
                {items.map(booking => (
                    <li key={booking.id}>
                        <BookingCard {...booking} />
                    </li>
                ))}
            </List>
        </>
    );
};

export default Booking;
